export default "__VITE_ASSET__S7FlF8xX__";